import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ProformaInvoiceApiModel } from '@rocksoft/inroom-sdk';

export const inRoomMobileFolioFeatureKey = 'mobile-folio';

export function selectMobileFolioIdFrom(mobileFolio: ProformaInvoiceApiModel): string {
  if (mobileFolio.Invoice && mobileFolio.Invoice.length > 0) {
    return mobileFolio.Invoice[0].ReservationId?.toString() ?? '';
  } else if (mobileFolio.Proforma && mobileFolio.Proforma.length > 0) {
    return mobileFolio.Proforma[0].ReservationId?.toString() ?? '';
  }

  return 'undefined';
}

export const adapter: EntityAdapter<ProformaInvoiceApiModel> = createEntityAdapter<ProformaInvoiceApiModel>({
  selectId: selectMobileFolioIdFrom,
});

export type MobileFolioState = EntityState<ProformaInvoiceApiModel>;

export const initialState: MobileFolioState = adapter.getInitialState();
